import axios from 'axios';
var apiUrl = "".concat(window.location.origin, "/wp-json/vape-shop/v1");
export var api = axios.create({
    baseURL: apiUrl,
    headers: {
        Authorization: 'Bearer 5b18a0713089a1f77501c9ce66a7affc9dd257009b54542918fb7969c8081c8f',
        'Content-Type': 'application/json',
    },
});
